var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"call-button btn btn-secondary",attrs:{"href":'tel:' + _vm.telNumber}},[_c('i',{staticClass:"fas fa-phone fa-rotate-90"}),_vm._v(" Call ")])}
var staticRenderFns = []

export { render, staticRenderFns }